import { Container, Card, Row, Col } from "react-bootstrap"

import '../styles/catalogos/catalogos.css'

function CatalogosIndex(){
    return (<>
        <Container fluid className="my-5">
            <Card className="shadow-1 mt-3 card-catalogo">
                <Card.Body>
                    <Row>
                        <Col xs="4" md="4" className="section-logo">
                            logo
                        </Col>
                        <Col xs="4" md="4">
                            tex
                        </Col>
                        <Col xs="4" md="4">
                            number
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </Container>
    </>)
}

export default CatalogosIndex